(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hoco-brand-intro"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hoco-brand-intro').forEach(section=>{
const paragraph=section.querySelector('.hoco-brand-paragraph');
const words=paragraph.textContent.trim().split(/\s+/);
paragraph.textContent='';
words.forEach((word,i)=>{const span=document.createElement('span');span.className='hoco-brand-word';span.textContent=word;paragraph.append(span);if(i<words.length-1)paragraph.append(document.createTextNode(' '))});
const spans=paragraph.querySelectorAll('.hoco-brand-word');
let queued=false;
const update=()=>{queued=false;const rect=section.getBoundingClientRect();const height=window.innerHeight;const progress=Math.max(0,Math.min(1,(height*.88-rect.top)/(height*.55)));const count=matchMedia('(prefers-reduced-motion: reduce)').matches?spans.length:Math.ceil(progress*spans.length);spans.forEach((span,index)=>span.classList.toggle('is-filled',index<count))};
const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update)}};
window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoco-cart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',e=>{const b=e.target.closest('[data-cart-step]');if(!b)return;const input=b.parentElement.querySelector('input');if(Number(b.dataset.cartStep)>0)input.stepUp();else input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));});
document.addEventListener('change',e=>{if(e.target.matches('.hoco-cart-quantity input')){const form=e.target.closest('form');form.requestSubmit(form.querySelector('[data-cart-update]'));}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoco-footer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-footer-top]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoco-fresh-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hoco-fresh-bar').forEach(nav => {
  const menus = [...nav.querySelectorAll('details[name="hoco-navigation"]')];
  const hoverMenus = menus.filter(menu => menu.matches('.hoco-fresh-sale,.hoco-fresh-collections,.hoco-fresh-reseller'));
  hoverMenus.forEach(menu => {
    menu.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse' || !window.matchMedia('(hover:hover)').matches) return;
      menus.forEach(other => { if (other !== menu) other.open = false; });
      menu.open = true;
    });
  });
  nav.addEventListener('pointerleave', event => {
    if (event.pointerType === 'mouse') hoverMenus.forEach(menu => { menu.open = false; });
  });
  nav.addEventListener('keydown', event => {
    if (event.key === 'Escape') menus.forEach(menu => { menu.open = false; });
  });
  document.addEventListener('pointerdown', event => {
    if (!nav.contains(event.target)) menus.forEach(menu => { menu.open = false; });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoco-product-detail"] && !Shopify.designMode) return;
  try {
    
function initHocoProduct(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const stage=root.querySelector('.hoco-pdp-stage'),slides=[...root.querySelectorAll('.hoco-pdp-slide')],thumbs=[...root.querySelectorAll('[data-target-media]')],labels=JSON.parse(root.querySelector('[data-pdp-labels]').textContent);
function selectMedia(id,animate=true){const slide=slides.find(s=>s.dataset.mediaId===id);if(!slide)return;stage.scrollTo({left:slide.offsetLeft-stage.firstElementChild.offsetLeft,behavior:animate&&!matchMedia('(prefers-reduced-motion:reduce)').matches?'smooth':'instant'});thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.targetMedia===id)));}
thumbs.forEach(t=>t.addEventListener('click',()=>selectMedia(t.dataset.targetMedia)));
const initial=root.querySelector('[data-initial]');if(initial)requestAnimationFrame(()=>selectMedia(initial.dataset.mediaId,false));
let timer;stage.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(()=>{const index=Math.round(stage.scrollLeft/stage.clientWidth);const id=slides[index]?.dataset.mediaId;thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.targetMedia===id)));slides.forEach((s,i)=>{if(i!==index)s.querySelectorAll('video').forEach(v=>v.pause());});},100);});
const dialog=root.querySelector('dialog');root.querySelectorAll('[data-zoom-src]').forEach(b=>b.addEventListener('click',()=>{dialog.querySelector('img').src=b.dataset.zoomSrc;dialog.showModal();}));dialog.querySelector('button').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
const descriptionDialog=root.querySelector('.hoco-pdp-description-dialog');root.querySelector('[data-description-open]').addEventListener('click',()=>descriptionDialog.showModal());descriptionDialog.querySelector('[data-description-close]').addEventListener('click',()=>descriptionDialog.close());descriptionDialog.addEventListener('click',e=>{if(e.target===descriptionDialog)descriptionDialog.close();});
const form=root.querySelector('form'),select=form.querySelector('[name=id]'),quantity=form.querySelector('[name=quantity]'),buttons=[...form.querySelectorAll('button[type=submit]')],feedback=root.querySelector('.hoco-pdp-feedback');
function updateVariant(){const o=select.selectedOptions[0],available=o.dataset.available==='true'&&root.dataset.comingSoon!=='true';root.querySelector('[data-price]').textContent=o.dataset.price;const compare=root.querySelector('[data-compare]'),saving=root.querySelector('[data-saving]'),discount=Number(o.dataset.compareRaw)>Number(o.dataset.priceRaw);compare.hidden=!discount;saving.hidden=!discount;compare.textContent=o.dataset.compare;saving.textContent=discount?Math.round((Number(o.dataset.compareRaw)-Number(o.dataset.priceRaw))*100/Number(o.dataset.compareRaw))+'% '+labels.off:'';root.querySelector('[data-stock]').textContent=root.dataset.comingSoon==='true'?'COMING SOON':available?labels.available:labels.soldOut;buttons.forEach(b=>b.disabled=root.dataset.comingSoon==='true'||!available);const sku=root.querySelector('[data-sku]');sku.textContent=o.dataset.sku||'';sku.parentElement.hidden=!o.dataset.sku;quantity.min=o.dataset.min||'1';quantity.step=o.dataset.step||'1';if(o.dataset.max)quantity.max=o.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;if(o.dataset.media)selectMedia(o.dataset.media);feedback.textContent='';const url=new URL(location.href);url.searchParams.set('variant',o.value);history.replaceState({},'',url);}
select.addEventListener('change',updateVariant);
root.querySelectorAll('[data-quantity]').forEach(b=>b.addEventListener('click',()=>{if(Number(b.dataset.quantity)>0)quantity.stepUp();else quantity.stepDown();quantity.dispatchEvent(new Event('change',{bubbles:true}));}));
let busy=false;form.addEventListener('submit',async e=>{e.preventDefault();if(busy||root.dataset.comingSoon==='true'||!form.reportValidity())return;busy=true;const buy=e.submitter?.hasAttribute('data-buy');buttons.forEach(b=>b.disabled=true);feedback.textContent='';try{const res=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const data=await res.json();if(!res.ok)throw new Error(data.description||labels.error);if(buy){location.assign((window.Shopify?.routes?.root||'/')+'checkout');return;}feedback.textContent=labels.added;document.dispatchEvent(new CustomEvent('cart:updated',{detail:{product:data}}));}catch(err){feedback.textContent=err.message||labels.error;}finally{busy=false;buttons.forEach(b=>b.disabled=root.dataset.comingSoon==='true'||select.selectedOptions[0].dataset.available!=='true');}});
}
document.querySelectorAll('.hoco-pdp').forEach(initHocoProduct);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.hoco-pdp').forEach(initHocoProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoco-reels"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hoco-reels').forEach(section=>{const videos=section.querySelectorAll('video');const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{const v=entry.target;v.muted=true;v.controls=false;if(entry.isIntersecting)v.play().catch(()=>{});else v.pause()}),{threshold:.2});videos.forEach(video=>{video.muted=true;video.controls=false;observer.observe(video)});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoco-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCountdowns(scope){
    (scope || document).querySelectorAll('[data-hoco-sale-countdown]').forEach(function(el){
      if(el.dataset.initialized === 'true')return;
      el.dataset.initialized='true';
      var target=Date.parse(el.dataset.deadline);
      var keys=['days','hours','minutes','seconds'];
      function update(){
        var left=Math.max(0,Math.floor((target-Date.now())/1000));
        var parts=[Math.floor(left/86400),Math.floor(left%86400/3600),Math.floor(left%3600/60),left%60];
        keys.forEach(function(key,i){var node=el.querySelector('[data-cd-'+key+']');if(node)node.textContent=String(parts[i]).padStart(2,'0')});
        if(left===0)clearInterval(interval);
      }
      var interval=setInterval(update,1000);update();
    });
  }
  initCountdowns(document);
  document.addEventListener('shopify:section:load',function(e){initCountdowns(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoco-stacked-banners"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hoco-banner-stack').forEach(stage=>{
 const viewport=stage.querySelector('.hoco-banner-viewport');
 const track=stage.querySelector('.hoco-banner-track');
 const cards=[...track.children];
 if(cards.length<2)return;
 const before=cards[cards.length-1].cloneNode(true),after=cards[0].cloneNode(true);
 [before,after].forEach(card=>{card.setAttribute('aria-hidden','true');card.querySelectorAll('a').forEach(a=>a.tabIndex=-1)});
 track.prepend(before);track.append(after);
 let index=1,startX=0,dragX=0,active=false,moved=false;
 const reduced=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
 const step=()=>cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
 const render=(animate=true)=>{
 const offset=(viewport.clientWidth-cards[0].getBoundingClientRect().width)/2-index*step()+dragX;
 track.style.transition=animate&&!reduced?'transform .38s cubic-bezier(.22,1,.36,1)':'none';
 track.style.transform='translate3d('+offset+'px,0,0)';
 [...track.children].forEach((card,i)=>{
 const distance=Math.max(-1.2,Math.min(1.2,i-index-dragX/step()));
 card.style.transition=animate&&!reduced?'transform .38s cubic-bezier(.22,1,.36,1)':'none';
 card.style.transform='translateX('+(-distance*cards[0].getBoundingClientRect().width*.12)+'px) perspective(1600px) rotateY('+(-distance*27)+'deg) scale('+(1+Math.abs(distance)*.055)+')';
 });
 };
 viewport.addEventListener('dragstart',event=>event.preventDefault());
 viewport.addEventListener('pointerdown',event=>{
 if(event.button!==0)return;
 active=true;moved=false;startX=event.clientX;dragX=0;
 viewport.setPointerCapture(event.pointerId);viewport.classList.add('is-dragging');render(false);
 });
 viewport.addEventListener('pointermove',event=>{
 if(!active)return;
 dragX=event.clientX-startX;
 if(Math.abs(dragX)>6)moved=true;
 render(false);
 });
 const finish=()=>{
 if(!active)return;
 active=false;viewport.classList.remove('is-dragging');
 if(Math.abs(dragX)>step()*.1)index=Math.max(0,Math.min(cards.length+1,index+(dragX<0?1:-1)));
 dragX=0;render();
 };
 viewport.addEventListener('pointerup',finish);
 viewport.addEventListener('pointercancel',finish);
 track.addEventListener('transitionend',()=>{
 if(index===0){index=cards.length;render(false)}
 else if(index===cards.length+1){index=1;render(false)}
 });
 viewport.addEventListener('click',event=>{if(moved){event.preventDefault();event.stopPropagation()}},true);
 viewport.tabIndex=0;viewport.setAttribute('aria-label','Banner carousel. Use left and right arrow keys.');
 viewport.addEventListener('keydown',event=>{
 if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;
 event.preventDefault();index=Math.max(0,Math.min(cards.length+1,index+(event.key==='ArrowRight'?1:-1)));render();
 });
 window.addEventListener('resize',()=>render(false));
 render(false);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoco-two-row-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hoco-reference-header').forEach(header=>{
const collection=header.querySelector('.hoco-reference-collection');
const closeOthers=current=>header.querySelectorAll('details[open]').forEach(item=>{if(item!==current)item.open=false});
collection.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){closeOthers(collection);collection.open=true}});
header.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse')collection.open=false});
header.querySelectorAll('details summary').forEach(summary=>summary.addEventListener('click',()=>{if(!summary.parentElement.open)closeOthers(summary.parentElement)}));
document.addEventListener('pointerdown',event=>{if(!header.contains(event.target))header.querySelectorAll('details').forEach(item=>item.open=false)});
document.addEventListener('keydown',event=>{if(event.key==='Escape')header.querySelectorAll('details').forEach(item=>item.open=false)});
});

document.addEventListener('pointerdown',event=>{document.querySelectorAll('.hoco-reference-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false})});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.hoco-reference-menu[open]').forEach(menu=>menu.open=false)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
